module.exports = __webpack_public_path__ + "img/credit_card_logo.9ec5474d.png";